export default "__VITE_ASSET__DJPnVGPk__"